module.exports = __webpack_public_path__ + "static/media/contentExample4.f2f81c31.png";